import commonViVN from '../shared/i18n/vi-VN';

export default {
  ...commonViVN,
  //routes
  "route.accounting": "Kế toán",
  "route.orderManagement": "Quản lý đơn hàng",
  "route.order.thermal": "In chuyển nhiệt",
  "route.order.pet": "In PET",
  "route.order.direct": "In trực tiếp",
  "route.cashbook.list": "Thu chi",
  "route.revenue": "Doanh thu",
  "route.revenue.thermal": "In chuyển nhiệt",
  "route.revenue.pet": "In PET",
  "route.revenue.direct": "In trực tiếp",
  "route.revenue.customer": "Khách hàng",
  "route.revenue.businessTeam": "Tổ kinh doanh",
  "route.revenue.colorTest": "Tổ test màu",
  "route.revenue.printTeam": "Tổ in",
  "route.revenue.drawingTeam": "Tổ vẽ",
  "route.debtManagement": "Công nợ khách hàng",
  "route.receiptOutside": "Phiếu thu ngoài",
  "route.orderDefects": "Đơn hàng lỗi hỏng",
  "route.list": "Danh sách",
  "route.shortlist": "Danh sách rút gọn",
  "route.management": "Quản lý công nợ kho thương mại",
  "route.commerce.warehouse": "Kho thương mại",
  "route.order.approval": "Đơn hàng đã duyệt",
  "route.payment.commerceWarehouse": "Tổng hợp doanh thu",
  /**
   * @devru
   */
  "route.payment.fabricTypeSummary": "Tổng hợp loại vải",
  "route.payment.summaryBySaler": "Tổng hợp NVKD",

  "route.total.warehouse": "Tổng hợp kho",
  "route.report": "Quản lý người dùng",
  "route.system": "Hệ thống",
  "route.settings": "Cài đặt",
  "route.goodsReceipt": "Phát sinh nhập",
  "route.goodsIssue": "Phát sinh xuất",
  "route.incurredCost": "Phát sinh thanh toán",
  "route.fabricInventoryManagement": "Quản lý loại vải",
};
